import { ConfigForData } from '@droplet-tech-code/core-common-types';
import {
  GetSupportRequestResponse,
  SupportRequestAddSupportNoteRequest,
  SupportRequestCancelCfarQuoteRequest,
  SupportRequestCancelKoalaQuoteRequest,
  SupportRequestCancelPendingPaymentRequest,
  SupportRequestCancelVIRequest,
  SupportRequestChangeAdminUserRequest,
  SupportRequestChangeLangRequest,
  SupportRequestChangeSelectionReferencesRequest,
  SupportRequestChangeStatusRequest,
  SupportRequestChangeSupportTypeRequest,
  SupportRequestClaimKoalaRequest,
  SupportRequestCreateBookingRequest,
  SupportRequestCreateChargeRequest,
  SupportRequestCreatePendingRefundRequest,
  SupportRequestDeleteReplyRequest,
  SupportRequestEditReplyRequest,
  SupportRequestFillDynamicTemplateAnswersRequest,
  SupportRequestFillDynamicTemplateAnswersResponse,
  SupportRequestGetKoalaQuoteRequest,
  SupportRequestGetTemplateAnswersResponse,
  SupportRequestResolveVIErrorRequest,
  SupportRequestResolveVIRequest,
  SupportRequestSendReminderRequest,
  SupportRequestSendReplyRequest,
  SupportRequestSubscribeCfarQuoteRequest,
  SupportRequestSubscribeKoalaQuoteRequest,
  SupportUpdateCheck,
} from '@naus-code/naus-admin-types';
import { ImageUploadResponse } from '@naus-code/naus-client-types';

import { rootApi } from '~/store/redux.utils';

const base_url = 'support-request/actions';
export const supportRequestActionsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    assignAdminUser: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestChangeAdminUserRequest
    >({
      query: (data) => ({
        url: `${base_url}/assign-admin-user/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        // 'User_Item',
        'getSupportRequestPending',
        'assignAdminUserFormConfig',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    assignAdminUserSelf: builder.mutation<
      GetSupportRequestResponse,
      Omit<SupportRequestChangeAdminUserRequest, 'adminUserId'>
    >({
      query: (data) => ({
        url: `${base_url}/assign-admin-user-self/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        // 'User_Item',
        'getSupportRequestPending',
        'assignAdminUserFormConfig',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),
    unassignAdminUserSelf: builder.mutation<
      GetSupportRequestResponse,
      Omit<SupportRequestChangeAdminUserRequest, 'adminUserId'>
    >({
      query: (data) => ({
        url: `${base_url}/unassign-admin-user-self/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        // 'User_Item',
        'getSupportRequestPending',
        'assignAdminUserFormConfig',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    unassignAdminUser: builder.mutation<
      GetSupportRequestResponse,
      Omit<SupportRequestChangeAdminUserRequest, 'adminUserId'>
    >({
      query: (data) => ({
        url: `${base_url}/unassign-admin-user/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        // 'User_Item',
        'getSupportRequestPending',
        'assignAdminUserFormConfig',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    assignAdminUserFormConfig: builder.query<ConfigForData, string>({
      query: (id) => ({
        url: `${base_url}/form-config/assign-admin-user/${id}`,
        method: 'GET',
      }),
      providesTags: ['*', 'assignAdminUserFormConfig'],
    }),
    sendCustomerReminder: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestSendReminderRequest
    >({
      query: (data) => ({
        url: `${base_url}/send-customer-reminder/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['sendCustomerReminder', 'getSupportRequest'],
    }),
    createPaymentChargeFormConfig: builder.query<ConfigForData, string>({
      query: (id) => ({
        url: `${base_url}/form-config/create-payment/${id}`,
        method: 'GET',
      }),
      providesTags: ['*', 'createPaymentChargeFormConfig', 'getSupportRequest'],
    }),

    createPaymentRefundFormConfig: builder.query<ConfigForData, string>({
      query: (id) => ({
        url: `${base_url}/form-config/create-refund/v1/${id}`,
        method: 'GET',
      }),
      providesTags: ['*', 'createPaymentRefundFormConfig', 'getSupportRequest'],
    }),

    // createPaymentCharge: builder.mutation<
    //   GetSupportRequestResponse,
    //   SupportRequestCreateChargeRequest
    // >({
    //   query: (data) => ({
    //     url: `${base_url}/create-payment-charge/`,
    //     method: 'POST',
    //     data,
    //   }),
    //   invalidatesTags: ['getSupportRequest'],
    // }),

    createPendingPaymentCharge: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCreateChargeRequest
    >({
      query: (data) => ({
        url: `${base_url}/create-pending-payment/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getProvisionalRequestsOpen'],
    }),

    createPendingPaymentRefund: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCreatePendingRefundRequest
    >({
      query: (data) => ({
        url: `${base_url}/create-pending-refund/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    approvePendingRefund: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCancelPendingPaymentRequest
    >({
      query: (data) => ({
        url: `${base_url}/approve-payment-refund/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'createPaymentRefundFormConfig',
        'getSupportRequest',
        'getBooking',
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    cancelPendingPayment: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCancelPendingPaymentRequest
    >({
      query: (data) => ({
        url: `${base_url}/cancel-pending-payment-charge/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'cancelPendingPayment',
        'getSupportRequest',
        'getSupportRequestPending',
        'getProvisionalRequestsOpen',
      ],
    }),

    cancelPendingRefund: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCancelPendingPaymentRequest
    >({
      query: (data) => ({
        url: `${base_url}/cancel-pending-refund/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'getBooking',
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    changeSupportStatus: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestChangeStatusRequest
    >({
      query: (data) => ({
        url: `${base_url}/change-support-status/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'changeSupportStatus',
        'getSupportRequest',
        // "getSupportRequestClosed",
        // "getSupportRequestPaused",
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    createBooking: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestCreateBookingRequest
    >({
      query: (data) => ({
        url: `${base_url}/create-booking/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    togglePendingOperatorResponse: builder.mutation<
      GetSupportRequestResponse,
      SupportUpdateCheck
    >({
      query: (data) => ({
        url: `${base_url}/toggle-pending-operator-response/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    // //--------------Notes--------------//
    addSupportNote: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestAddSupportNoteRequest
    >({
      query: (data) => ({
        url: `${base_url}/add-support-note/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['addSupportNote', 'getSupportRequest'],
    }),

    //---------------Template Answers------------------//

    getTemplateAnswers: builder.query<SupportRequestGetTemplateAnswersResponse, void>({
      query: () => ({
        url: `${base_url}/get-template-answers/`,
        method: 'GET',
      }),
      providesTags: ['*', 'getTemplateAnswers'],
    }),
    fillDynamicTemplateAnswer: builder.mutation<
      SupportRequestFillDynamicTemplateAnswersResponse,
      SupportRequestFillDynamicTemplateAnswersRequest
    >({
      query: (data) => ({
        url: `${base_url}/fill-template/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['fillDynamicTemplateAnswer'],
    }),

    // @Post('/img-upload/reply/v1/')
    // replyToSupportUploadImage(@RequestDeco() body: Request): Promise<ImageUploadResponse> {
    //     return this._supportRequestService.getReplyImageToken(body);
    // }

    replyToSupportUploadImage: builder.mutation<ImageUploadResponse, FormData>({
      query: (data) => ({
        url: `${base_url}/img-upload/reply/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    sendReply: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestSendReplyRequest
    >({
      query: (data) => ({
        url: `${base_url}/send-reply/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getProvisionalRequestsOpen'],
    }),

    // @Get('/form-config/send-reply/', [applyRoleValidation(['ADMIN', 'SYSTEM'])])
    // sendReplyFormConfig(): Promise<ConfigForData> {
    //     return this._supportRequestService.sendReplyFormConfig();
    // }

    sendReplyFormConfig: builder.query<ConfigForData, void>({
      query: () => ({
        url: `${base_url}/form-config/send-reply/`,
        method: 'GET',
      }),
      providesTags: ['*', 'sendReplyFormConfig'],
    }),
    editReplyFormConfig: builder.query<ConfigForData, void>({
      query: () => ({
        url: `${base_url}/form-config/edit-reply/`,
        method: 'GET',
      }),
      providesTags: ['*', 'editReplyFormConfig'],
    }),
    editReply: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestEditReplyRequest
    >({
      query: (data) => ({
        url: `${base_url}/edit-reply/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),
    deleteReply: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestDeleteReplyRequest
    >({
      query: (data) => ({
        url: `${base_url}/delete-reply/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),
    // @Post('/change-support-language/', [applyRoleValidation(['ADMIN', 'SYSTEM'])])
    //     changeSupportLang(
    //         @Body() body: SupportRequestChangeLangRequest,
    //     ): Promise<GetSupportRequestResponse> {
    //         return this._supportRequestService.changeSupportLang(body);
    //     }
    changeSupportLang: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestChangeLangRequest
    >({
      query: (data) => ({
        url: `${base_url}/change-support-language/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getTemplateAnswers', 'getSupportRequest'],
    }),
    // @Post('/change-selection-references/', [applyRoleValidation(['ADMIN', 'SYSTEM'])])
    //     changeSelectionReferences(
    //         @Body() body: SupportRequestChangeSelectionReferencesRequest,
    //     ): Promise<GetSupportRequestResponse> {
    //         return this._supportRequestService.changeSelectionReferences(body);
    //     }

    changeSelectionReferences: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestChangeSelectionReferencesRequest
    >({
      query: (data) => ({
        url: `${base_url}/change-selection-references/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),
    // @Get('/form-config/change-support-type/', [applyRoleValidation(['ADMIN', 'SYSTEM'])])
    // changeSupportTypeFormConfig(): Promise<ConfigForData> {
    //     return this._supportRequestService.changeSupportTypeConfig();
    // }

    // @Post('/change-support-type/', [applyRoleValidation(['ADMIN', 'SYSTEM'])])
    // changeSupportType(
    //     @Body() body: SupportRequestChangeSupportTypeRequest,
    // ): Promise<GetSupportRequestResponse> {
    //     return this._supportRequestService.changeSupportType(body);
    // }

    getChangeSupportTypeFormConfig: builder.query<ConfigForData, void>({
      query: () => ({
        url: `${base_url}/form-config/change-support-type/`,
        method: 'GET',
      }),
      providesTags: ['*', 'changeSupportTypeFormConfig'],
    }),

    changeSupportType: builder.mutation<
      GetSupportRequestResponse,
      SupportRequestChangeSupportTypeRequest
    >({
      query: (data) => ({
        url: `${base_url}/change-support-type/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'changeSupportTypeFormConfig',
        'getSupportRequestClosed',
        'getSupportRequestPaused',
        'getSupportRequestPending',
        'getVIRequestsOpen',
        'getProvisionalRequestsOpen',
      ],
    }),

    toggleAutoUpdateAgent: builder.mutation<
      GetSupportRequestResponse,
      SupportUpdateCheck
    >({
      query: (data) => ({
        url: `${base_url}/toggle-auto-translate-agent`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    toggleAutoUpdateCustomer: builder.mutation<
      GetSupportRequestResponse,
      SupportUpdateCheck
    >({
      query: (data) => ({
        url: `${base_url}/toggle-auto-translate-customer`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    // @Post('/approve-vi-changes/v1/', [applyRoleValidation(['CUSTOMER_SUPPORT'])])
    // approveVIChanges(@Body() body: SupportRequestResolveVIRequest) {
    //     return this._supportRequestService.resolveChanges({ ...body, isApproved: true });
    // }

    approveVIChanges: builder.mutation<void, SupportRequestResolveVIRequest>({
      query: (data) => ({
        url: `${base_url}/approve-vi-changes/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    // @Post('/reject-vi-changes/v1/', [applyRoleValidation(['CUSTOMER_SUPPORT'])])
    // rejectVIChanges(@Body() body: SupportRequestResolveVIRequest) {
    //     this._supportRequestService.resolveChanges({ ...body, isApproved: false });
    // }

    rejectVIChanges: builder.mutation<void, SupportRequestResolveVIRequest>({
      query: (data) => ({
        url: `${base_url}/reject-vi-changes/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    resolveVIError: builder.mutation<void, SupportRequestResolveVIErrorRequest>({
      query: (data) => ({
        url: `${base_url}/resolve-vi-error/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    cancelVIBooking: builder.mutation<void, SupportRequestCancelVIRequest>({
      query: (data) => ({
        url: `${base_url}/cancel-vi-booking/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    overrideConfirmVIBooking: builder.mutation<void, SupportRequestCancelVIRequest>({
      query: (data) => ({
        url: `${base_url}/override-confirm-vi-booking/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    //PROVISIONAL

    confirmProvisionalBooking: builder.mutation<void, SupportUpdateCheck>({
      query: (data) => ({
        url: `${base_url}/confirm-provisional-booking/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'getProvisionalRequestsOpen',
        'getSupportRequestPending',
        'getSupportRequestClosed',
        'getBooking',
        'getBookingFromRef',
        'getPurchase',
        'PurchaseListResponse',
      ],
    }),

    cancelProvisionalBooking: builder.mutation<void, SupportUpdateCheck>({
      query: (data) => ({
        url: `${base_url}/cancel-provisional-booking/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'getSupportRequest',
        'getProvisionalRequestsOpen',
        'getSupportRequestPending',
        'getSupportRequestClosed',
        'getBooking',
        'getBookingFromRef',
        'getPurchase',
        'PurchaseListResponse',
      ],
    }),

    //KOALA

    claimKoala: builder.mutation<void, SupportRequestClaimKoalaRequest>({
      query: (data) => ({
        url: `${base_url}/claim-koala/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getBooking'],
    }),

    voidKoala: builder.mutation<void, SupportRequestClaimKoalaRequest>({
      query: (data) => ({
        url: `${base_url}/void-koala/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getBooking'],
    }),

    getKoalaQuote: builder.mutation<void, SupportRequestGetKoalaQuoteRequest>({
      query: (data) => ({
        url: `${base_url}/attach-koala-quote/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    cancelKoalaQuote: builder.mutation<void, SupportRequestCancelKoalaQuoteRequest>({
      query: (data) => ({
        url: `${base_url}/cancel-koala-quote/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getBooking'],
    }),

    subscribeKoalaQuote: builder.mutation<void, SupportRequestSubscribeKoalaQuoteRequest>(
      {
        query: (data) => ({
          url: `${base_url}/subscribe-koala-quote/v1/`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['getSupportRequest', 'getBooking'],
      },
    ),

    //CFAR

    getCfarQuote: builder.mutation<void, SupportRequestGetCfarQuoteRequest>({
      query: (data) => ({
        url: `${base_url}/attach-cfar-quote/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest'],
    }),

    cancelCfarQuote: builder.mutation<void, SupportRequestCancelCfarQuoteRequest>({
      query: (data) => ({
        url: `${base_url}/cancel-cfar-quote/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getBooking'],
    }),

    subscribeCfarQuote: builder.mutation<void, SupportRequestSubscribeCfarQuoteRequest>({
      query: (data) => ({
        url: `${base_url}/subscribe-cfar-quote/v1/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['getSupportRequest', 'getBooking'],
    }),
  }),
});

export interface SupportRequestGetCfarQuoteRequest extends SupportUpdateCheck {
  bookingId: string;
  cfarDetails: ManualCfarQuoteDetails;
}

export interface ManualCfarQuoteDetails {
  newPrice: number;
  passengerCount: number;
  newDepartureDateTime: string;
}
